// A two-statement report stores "primary secondary" in branch and
// "secondary primary" in second_branch; a single-statement report stores the
// same location in both. Works out the readable name from the location list.
export function splitReportName(report, locationNames = []) {
  const branch = report?.branch || "";
  const second = report?.second_branch || "";
  if (branch === second) return { single: true, primary: branch, secondary: "" };
  for (const p of locationNames) {
    if (!branch.startsWith(p + " ")) continue;
    const s = branch.slice(p.length + 1);
    if (second === `${s} ${p}`) return { single: false, primary: p, secondary: s };
  }
  const words = branch.split(" ");
  return {
    single: false,
    primary: words.slice(0, 2).join(" "),
    secondary: words.slice(2).join(" "),
  };
}

export function reportLabel(report, locationNames = []) {
  const { single, primary, secondary } = splitReportName(report, locationNames);
  return single ? primary : `${primary} ↔ ${secondary}`;
}
